<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4>Thông tin chi tiết nhân viên</h4>
          </div>
          <div class="text-right mr-2">
            <el-button
              v-if="currentTab == 'HSCN' && !mData.haveDraff"
              class="btn-default"
              round
              @click="sendRequestApprove()"
            >
              Cập nhật
              <i class="isax-card-send"></i>
            </el-button>
            <el-button
              v-if="currentTab == 'HSCN' && mData.haveDraff"
              class="btn-default"
              round
              @click="showRequestApprove()"
            >
              Xem lại yêu cầu chỉnh sửa
              <i class="isax-card-send"></i>
            </el-button>
            <el-button
              class="btn-default"
              round
              @click="fn_go()"
            >
              Quay lại
              <i class="icon-Undo"></i>
            </el-button>
          </div>
        </div>
        <div class="mt-2 scroll-css">
          <el-alert
            v-if="mData.approvalStatus.visible"
            class="mb-3 approval-status-alert"
            :title="mData.approvalStatus.title"
            :type="mData.approvalStatus.type"
            :closable="false"
            show-icon
          >
            <template slot>
              <div>{{ mData.approvalStatus.message }}</div>
            </template>
          </el-alert>
          <b-row>
            <b-col md="12" class="data_list_employee">
              <div class="tab-css">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                  <el-tab-pane label="Hồ sơ cá nhân" name="HSCN">
                    <ThongTinNhanVien
                      :dataDraff="mData.dataEmployeeDraff"
                      :dataSignatureDraff="mData.dataEmployeeSignatureDraff"
                      :haveDraff="mData.haveDraff"
                      v-if="currentTab == 'HSCN'"
                    ></ThongTinNhanVien>
                  </el-tab-pane>
                  <el-tab-pane label="Hợp đồng" name="HopDong" v-if="mData.dataDefault.listFeature.includes('FT1701')">
                    <HopDong
                      v-if="currentTab == 'HopDong'"
                    ></HopDong>
                  </el-tab-pane>
                  <el-tab-pane label="Tài sản" name="TaiSan" v-if="mData.dataDefault.listFeature.includes('FT1501')">
                    <TaiSan
                      v-if="currentTab == 'TaiSan'"
                      :listEmployee="mData.dataDefault.listEmployee"
                    >
                    </TaiSan>
                  </el-tab-pane>
                  <el-tab-pane label="Nghỉ phép" name="NghiPhep">
                    <NghiPhep
                      v-if="currentTab == 'NghiPhep'"
                    ></NghiPhep>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <el-dialog
      title="Chi tiết yêu cầu chỉnh sửa"
      class="dialog-employee-info"
      width="98%"
      top="10px"
      :visible.sync="showDialogDataApprove"
      :before-close="beforeCloseDialog"
    >
      <div class="text-right mb-2">
        <el-button
          type="primary"
          class="btn-default"
          round
          @click="sendRequestApprove()"
        >
          Gửi yêu cầu
          <i class="isax-card-send"></i>
        </el-button>
      </div>
      <div class="employee-data">
        <ThongTinNhanVien
          @statusSubmit="statusSubmit"
          :dataDraff="mData.dataEmployeeDraff"
          :dataSignatureDraff="mData.dataEmployeeSignatureDraff"
          :haveDraff="mData.haveDraff"
          :viewType="'showDataApprove'"
        ></ThongTinNhanVien>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ThongTinNhanVien from "../../../component/NhanVien/ThongTinNhanVien";
import HopDong from "../../../component/NhanVien/HopDong";
import TaiSan from "../../../component/NhanVien/TaiSan";
import NghiPhep from "../../../component/NhanVien/NghiPhep";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import EventBus from "../../../service/EventBus";
import EmployeeDraffApi from "../../../moduleApi/EmployeeDraffApi";
import EmployeeSignatureDraffApi from "../../../moduleApi/EmployeeSignatureDraffApi";

export default {
  components: {
    ThongTinNhanVien,
    HopDong,
    TaiSan,
    NghiPhep
  },
  data() {
    return {
      activeName: "HSCN",
      currentTab: "HSCN",
      imgUrl: ExtensionService.urlImg,
      showDialogDataApprove: false,
      mData: {
        routerParamId: "",
        moduleName: "EmployeeInfo", //requied
        viewMode: "crete",
        dataEmployeeDraff: undefined,
        dataEmployeeSignatureDraff: undefined,
        haveDraff: false,
        approvalStatus: {
          visible: false,
          type: "warning",
          title: "",
          message: "",
        },
        dataDefault: {
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listTrangThai: [],
          listEmployee: [],
          listFeature: MethodService.getListFeatures(),
        },
        currentPath: "",
      },
      query: {},
      currentTab: 'HSCN',
    };
  },
  methods: {
    async resolveApproverName(approverId) {
      if (!approverId) return "";

      let approver = this.mData.dataDefault.listEmployee.find(
        (item) => item.id == approverId
      );
      if (approver) {
        return approver.administrative_info &&
          approver.administrative_info.name &&
          approver.administrative_info.name.full_name
          ? approver.administrative_info.name.full_name
          : "";
      }

      try {
        const employeeApiRes = await EmployeeApi.findById(approverId, true);
        if (employeeApiRes.result) {
          approver = employeeApiRes.result;
          this.mData.dataDefault.listEmployee.push(approver);
          return approver.administrative_info &&
            approver.administrative_info.name &&
            approver.administrative_info.name.full_name
            ? approver.administrative_info.name.full_name
            : "";
        }
      } catch (error) {
        return "";
      }

      return "";
    },
    isSignatureDraft(draft) {
      return draft && Array.isArray(draft.image_ids) && !draft.employee_no && !draft.administrative_info;
    },
    isActionableDraft(draft) {
      if (!draft) return false;
      if (this.isSignatureDraft(draft)) {
        return (draft.image_ids || []).filter((id) => !!id).length > 0;
      }
      return true;
    },
    isPendingApproval(draft) {
      if (!draft || !this.isActionableDraft(draft)) return false;
      if (!draft.approver) return true;

      const status = String(draft.approver.status || "").toUpperCase();
      const resolvedStatuses = [
        "APPROVED",
        "REJECTED",
        "REJECT",
        "UNAPPROVED",
        "CANCELLED",
        "CANCELED",
      ];

      if (resolvedStatuses.includes(status)) {
        return false;
      }

      if (draft.approver.approver_at && status !== "WAITING_FOR_APPROVAL") {
        return false;
      }

      return true;
    },
    getLatestDraft(drafts) {
      return drafts
        .filter(Boolean)
        .sort((firstItem, secondItem) => {
          const firstTime = new Date(
            firstItem.updated_at || firstItem.created_at || 0
          ).getTime();
          const secondTime = new Date(
            secondItem.updated_at || secondItem.created_at || 0
          ).getTime();

          return secondTime - firstTime;
        })[0];
    },
    async updateApprovalStatus(employeePendingDraft, signaturePendingDraft, employeeLatestDraft, signatureLatestDraft) {
      const pendingDraft = this.getLatestDraft(
        [employeePendingDraft, signaturePendingDraft].filter((item) =>
          this.isPendingApproval(item)
        )
      );

      const latestActiveDraft = this.getLatestDraft(
        [employeeLatestDraft, signatureLatestDraft].filter((item) =>
          this.isPendingApproval(item)
        )
      );

      const draftForDisplay = pendingDraft || latestActiveDraft;

      if (!draftForDisplay || !this.isPendingApproval(draftForDisplay)) {
        this.mData.approvalStatus = {
          visible: false,
          type: "warning",
          title: "",
          message: "",
        };
        return;
      }

      const approverId =
        draftForDisplay.approver && draftForDisplay.approver.approver_id
          ? draftForDisplay.approver.approver_id
          : "";
      const approverName = await this.resolveApproverName(approverId);

      this.mData.approvalStatus = {
        visible: true,
        type: "warning",
        title: "Yêu cầu chỉnh sửa đang chờ duyệt",
        message: approverName
          ? `Yêu cầu của bạn đang chờ ${approverName} duyệt.`
          : "Yêu cầu của bạn đang chờ bộ phận HR/Admin duyệt.",
      };
    },
    //Lấy bản nháp thông tin nhân viên theo id
    async fn_getEmployeeDraff(id){
      const [
        employeeDraffRes,
        employeeSignatureDraffApiRes,
        employeeDraffLatestRes,
        employeeSignatureDraffLatestRes,
      ] = await Promise.all([
        EmployeeDraffApi.list({
          filters: `employee_id=${id}&approver:is_null:true`
        }),
        EmployeeSignatureDraffApi.list({
          filters: `employee_id=${id}&approver:is_null:true`
        }),
        EmployeeDraffApi.list({
          filters: `employee_id=${id}`,
          sort: "-created_at",
          limit: 1,
        }, true),
        EmployeeSignatureDraffApi.list({
          filters: `employee_id=${id}`,
          sort: "-created_at",
          limit: 1,
        }, true),
      ]);
      const pendingEmployeeDraft = (employeeDraffRes.result || []).find((item) =>
        this.isPendingApproval(item)
      );
      const pendingSignatureDraft = (employeeSignatureDraffApiRes.result || []).find((item) =>
        this.isPendingApproval(item)
      );

      if (pendingEmployeeDraft || pendingSignatureDraft) {
        this.mData.dataEmployeeDraff = pendingEmployeeDraft || employeeDraffRes.result[0];
        this.mData.dataEmployeeSignatureDraff = pendingSignatureDraft || employeeSignatureDraffApiRes.result[0];
        this.mData.haveDraff = true;
      } else {
        this.mData.dataEmployeeDraff = undefined;
        this.mData.dataEmployeeSignatureDraff = undefined;
        this.mData.haveDraff = false;
      }

      await this.updateApprovalStatus(
        employeeDraffRes.result[0],
        employeeSignatureDraffApiRes.result[0],
        employeeDraffLatestRes.result[0],
        employeeSignatureDraffLatestRes.result[0]
      );
    },
    statusSubmit(data) {
      if (data.status === true) {
        this.beforeCloseDialog();
      }
    },
    sendRequestApprove(){
      let eventName = "sendRequestApprove";
      EventBus.$emit(eventName, {});

    },
    beforeCloseDialog(){
      this.showDialogDataApprove = false;
    },
    showRequestApprove(){
      this.showDialogDataApprove = true;
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.currentTab = tab.name;
      if (tab.name == 'TaiSan' && this.$route.query.asset_names ||
        tab.name == 'TaiSan' && this.$route.query.identity ||
        tab.name == 'TaiSan' && this.$route.query.is_broken ||
        tab.name == 'TaiSan' && this.$route.query.status
      ) {
        this.query = { ...this.$route.query, tab: tab.name};
      } else {
        this.query = {
          tab: this.activeName,
        }
      }
      this.replaceRoute();
    },
    replaceRoute() {
      this.$router.replace({
        name: this.$router.currentRoute.name,
        params: { id: this.$router.currentRoute.params.id },
        query: this.query,
      }).catch(() => {});
    },
    fn_go() {
      this.$router.go(-1);
    },

    fn_hashUrl() {
      if (this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.asset_names ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.identity ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.is_broken ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.status
      ) {
        this.query = this.$route.query;
      } else {
        this.query = {
          tab: this.activeName,
        }
      }
    },
  },
  created() {
    this.fn_hashUrl();
    if (this.$router.currentRoute.params.id) {
      this.mData.routerParamId = this.$router.currentRoute.params.id;
      this.fn_getEmployeeDraff(this.$router.currentRoute.params.id);
    }
    if (this.$router.currentRoute.query.tab) {
      if (
          !this.mData.dataDefault.listFeature.includes('FT1501') && this.$router.currentRoute.query.tab == 'TaiSan' ||
          !this.mData.dataDefault.listFeature.includes('FT1701') && this.$router.currentRoute.query.tab == 'HopDong'
        )
      {
        this.activeName = 'HSCN';
        this.currentTab = 'HSCN';
      } else {
        this.activeName = this.$router.currentRoute.query.tab;
        this.currentTab = this.$router.currentRoute.query.tab;
      }
    }
    this.replaceRoute();

    EventBus.$off("changeEmployeeDraff");
    EventBus.$on("changeEmployeeDraff", () => {
      this.fn_getEmployeeDraff(this.$router.currentRoute.params.id);
    });
  },
  activated() {
    if (this.$router.currentRoute.params.id) {
      this.fn_getEmployeeDraff(this.$router.currentRoute.params.id);
    }
  },
  mounted() {
    this.mData.currentPath = this.$router.currentRoute.fullPath;
  },
};
</script>

<style scoped>
.approval-status-alert {
  margin-bottom: 16px;
}
</style>

<style scoped>
[class^="isax-"], [class*=" isax-"] {
  margin-left: 15px;
  font-size: 18px !important;
}
.table-employee .el-table {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
::v-deep .el-form-item__label {
  font-size: 14px;
}
::v-deep .tab-content {
  /* max-width: calc(100vw - 390px); */
  border: none;
}
::v-deep .table-employee .el-table__row {
  background-color: #fff !important;
}
::v-deep .table-employee .el-table__row {
  height: 40px;
}
::v-deep .table-employee .el-table__row td div {
  text-transform: uppercase;
}
::v-deep .table-employee .el-table__row:hover {
  cursor: pointer;
}
::v-deep .table-employee .el-table__row td div:hover {
  color: #39a2db;
}
.data_list_employee {
  padding: 0 5px 0 10px;
}
::v-deep .el-tabs--card > .el-tabs__header {
  margin-bottom: 5px;
}
::v-deep .table-employee .active-tb {
  background-color: #e8f0f2 !important;
  color: #39a2db;
  font-weight: bold;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #c8ced3;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 10px;
}
::v-deep .el-tabs__item.is-top.is-active {
  background-color: #66b1ff;
  color: #fff;
  border-color: #66b1ff;
  font-weight: bold;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
::v-deep .employee_list {
  max-height: calc(100vh - 160px);
}
::v-deep .employee_list .el-table__body-wrapper {
  max-height: calc(100vh - 160px);
}
::v-deep .el-table .cell {
  padding: 0 5px;
}
::v-deep .dialog-employee-info .el-dialog {
  margin: 0 auto 20px;
}
::v-deep .dialog-employee-info .el-dialog .el-dialog__body {
  padding: 10px 15px;
}
::v-deep .dialog-employee-info .el-dialog .el-dialog__body .employee-data {
  max-height: calc(100vh - 140px);
  overflow: auto;
}
</style>
